<template>
  <div class="app-container">
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick" class="cardTabs">
      <el-tab-pane label="统计" name="list">
        <list ref="list">
          <template slot="toolbar-right">
            <el-button size="mini" type="success" plain @click="onExport('list')" v-if="!isMB">导出</el-button>
          </template>
        </list>
      </el-tab-pane>
      <el-tab-pane label="考勤日志" name="list2">
        <list2 ref="list2">
          <template slot="toolbar-right">
            <el-button size="mini" type="success" plain @click="onExport('list2')" v-if="!isMB">导出</el-button>
          </template>
        </list2>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import list from "@/components/at/staystatic/list";
import list2 from "@/components/at/staystatic/list2";

export default {
  name: "statistics",
  components: {
    list,
    list2
  },
  data() {
    return {
      tabName: "list",
      pre: "",
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    this.handleClick();
  },
  methods: {
    handleClick() {
      if(this.tabName != this.pre) {
        this.pre = this.tabName;
        this.$refs[this.tabName].query();
      }
    },
    onExport(name) {
      this.$refs[name].onExport();
    },
  },
};
</script>
<style lang="scss">
</style>